import httpApi from "@utils/httpApi";
import { AxiosResponse } from "axios";
import { ApiResponse } from "@src/types/httpApi";
import { IInvoice, CreateInvoicePayload } from "@src/types/invoice";

/**
 * Fetch all invoices (for Admins/Managers)
 */
export const fetchInvoices = async (
  page: number = 1
): Promise<AxiosResponse<ApiResponse<IInvoice[]>>> => {
  const queryParams = new URLSearchParams();
  queryParams.append("sort", "timestamp:desc");
  queryParams.append("populate", "curator");
  queryParams.append("pagination[page]", String(page));
  queryParams.append("pagination[pageSize]", "50");

  return httpApi.get(`/api/invoice-forms?${queryParams.toString()}`);
};

/**
 * Fetch invoices for a specific curator
 */
export const fetchMyInvoices = async (
  curatorId?: string,
  page: number = 1
): Promise<AxiosResponse<ApiResponse<IInvoice[]>>> => {
  if (!curatorId) {
    return {
      data: {
        data: [],
        meta: {
          pagination: { page: 1, pageSize: 50, pageCount: 0, total: 0 },
        },
      },
    } as any;
  }

  const queryParams = new URLSearchParams();
  queryParams.append("filters[curator][documentId][$eq]", curatorId);
  queryParams.append("sort", "timestamp:desc");
  queryParams.append("populate", "curator");
  queryParams.append("pagination[page]", String(page));
  queryParams.append("pagination[pageSize]", "50");

  return httpApi.get(`/api/invoice-forms?${queryParams.toString()}`);
};

/**
 * Create a new invoice
 */
export const createInvoice = async (
  payload: CreateInvoicePayload
): Promise<AxiosResponse<{ data: IInvoice }>> => {
  const body = {
    data: payload,
  };

  return httpApi.post("/api/invoice-forms", body);
};

/**
 * Update an existing invoice
 */
export const updateInvoice = async (
  documentId: string,
  payload: Partial<IInvoice>
): Promise<AxiosResponse<{ data: IInvoice }>> => {
  const body = {
    data: payload,
  };

  return httpApi.put(`/api/invoice-forms/${documentId}`, body);
};

/**
 * Trigger PDF generation for an invoice
 */
export const submitInvoice = async (
  documentId: string
): Promise<AxiosResponse<{ data: IInvoice }>> => {
  return httpApi.post(`/api/invoice-forms/${documentId}/submit`);
};

/**
 * Fetch a single invoice by its documentId
 */
export const fetchInvoiceById = async (
  documentId: string
): Promise<AxiosResponse<{ data: IInvoice }>> => {
  return httpApi.get(`/api/invoice-forms/${documentId}`);
};
